import { AlertTriangle, Inbox, Loader2, RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";

export function LoadingState({ label = "Carregando...", testId = "loading-state" }) {
  return (
    <div
      data-testid={testId}
      className="flex flex-col items-center justify-center gap-3 py-24 text-muted-foreground"
    >
      <Loader2 className="h-6 w-6 animate-spin text-primary" />
      <span className="text-sm">{label}</span>
    </div>
  );
}

export function ErrorState({ message, onRetry, testId = "error-state" }) {
  return (
    <div
      data-testid={testId}
      className="flex flex-col items-center justify-center gap-4 rounded-md border border-destructive/40 bg-destructive/5 py-16 text-center"
    >
      <AlertTriangle className="h-7 w-7 text-destructive" />
      <div>
        <p className="font-heading font-semibold text-foreground">
          Não foi possível carregar os dados
        </p>
        <p className="mt-1 text-sm text-muted-foreground">
          {message || "Tente novamente em instantes."}
        </p>
      </div>
      {onRetry && (
        <Button
          data-testid="retry-button"
          variant="outline"
          size="sm"
          onClick={onRetry}
          className="gap-2"
        >
          <RefreshCw className="h-4 w-4" />
          Tentar novamente
        </Button>
      )}
    </div>
  );
}

export function EmptyState({ message = "Nenhum dado para o período.", testId = "empty-state" }) {
  return (
    <div
      data-testid={testId}
      className="flex flex-col items-center justify-center gap-3 py-16 text-center text-muted-foreground"
    >
      <Inbox className="h-7 w-7" />
      <p className="text-sm">{message}</p>
    </div>
  );
}
